<!--
 * @Author: 月魂
 * @Date: 2021-06-02 09:37:00
 * @LastEditTime: 2021-07-04 17:06:52
 * @LastEditors: 月魂
 * @Description: 览古观今
 * @FilePath: \nepal\src\components\warriors.vue
-->
<template>
  <div class="box">
    <div class="header">
      <span class="header-text">{{ this.$t('title') }}</span>
      <NavMenu class="nav" />
      <div class="header-right">
        <!-- <van-button class="btn" size="small" type="default" v-if="selectedLang === 'en'" @click="changeLang('zh-CN')">En</van-button> -->
        <!-- <van-button class="btn" size="small" type="default" v-else @click="changeLang('en')">中文</van-button> -->
        <Menu class="menu" />
      </div>
    </div>
    <img src="../assets/warriors.jpg" alt="" class="pic">
    <div class="cont">
      <div class="title" :class="selectedLang === 'en' ? 'en-title' : ''">
        {{ this.$t('warriors.title') }}
      </div>
      <div class="part">
        <h4>{{ this.$t('warriors.part1.title') }}</h4>
        <div class="title" :class="selectedLang === 'en' ? 'en-title' : ''">
          {{ this.$t('warriors.part1.article') }}
        </div>

        <img src="../assets/guide_mobile.jpg" alt="" class="mobile">
        <img src="../assets/guide_pc.jpg" alt="" class="pc">

        <div class="title guide_title">{{ this.$t('warriors.des') }}</div>
        <div class="iframe-box">
          <iframe
            id="inlineFrameExample"
            title="Inline Frame Example"
            src="https://baikebcs.bdimg.com/baike-museum3d/qinshihuang/index.html"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '../components/menu.vue'
import NavMenu from '../components/nav.vue'
import Footer from '../components/footer.vue'

export default {
  name: 'Warriors',
  components: {
    Menu,
    NavMenu,
    Footer
  },
  data() {
    return {
      selectedLang: 'en'
    }
  },
  mounted() {
    const lang = localStorage.getItem('locale')
    this.selectedLang = lang || 'en'
  },
  methods: {
    changeLang(val) {
      this.selectedLang = val
      this.$i18n.locale = val
      localStorage.setItem('locale', val)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  background-color: #02478a;
  color: #fff;
  .header {
    height: 40px;
    display: flex;
    padding: 0 10px;
    overflow: hidden;
    justify-content: space-between;
    .menu {
      display: block;
    }
    .nav {
      display: none;
    }
    @media (min-width: 800px) {
      .nav {
        display: block;
      }
      .menu {
        display: none;
      }
    }
    .header-text {
      display: inline-block;
      line-height: 40px;
    }
    .header-right {
      display: flex;
      .btn {
        margin-top: 4px;
        margin-right: 10px;
      }
    }
  }
  .pic {
    width: 100%;
  }
  .cont {
    .pic {
      margin-top: 10px;
      max-height: 150px;
    }
    padding: 10px;
    .part {
      h4 {
        margin: 10px 0;
        color: #fff;
      }
      @media (min-width: 1200px) {
        width: 1200px;
        margin: auto;
      }
    }
  }
  .iframe-box {
    height: 460px;
    display: flex;
    justify-content: center;
    -webkit-overflow-scrolling: touch;
    iframe {
      height: 100%;
    }
  }
  @media (min-width: 800px) {
    .iframe-box {
      width: 100%;
      height: 600px;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.guide_title {
  margin: 10px 0;
  text-indent: 0;
}
.mobile {
  width: 100%;
  height: 100%;
  display: block;
}
.pc {
  width: 100%;
  height: 100%;
  display: none;
}
@media (min-width: 800px) {
  .mobile {
    display: none;
  }
  .pc {
    display: block;
  }
}
</style>
